import { TabbedGroup } from "../../../components/TabbedGroup";
import { AdminPermissions as AP } from "../../../lib/data";
import Users from "../Users";
import Verification from "../Verification";
import SocialLinks from "../Social";
import Devices from "../Devices";
import Deletions from "../Users/Deletions";
import Archive from "../Users/Archive";
import Squads from "../Squads";

export default function Members() {
  return (
    <TabbedGroup
      tabs={[
        { value: "users", label: "Users", permission: AP.MANAGE_USERS, element: <Users /> },
        { value: "verification", label: "Verification", permission: AP.MANAGE_VERIFICATION, element: <Verification /> },
        { value: "social", label: "Social Links", permission: AP.MANAGE_USERS, element: <SocialLinks /> },
        { value: "devices", label: "Devices", permission: AP.MANAGE_USERS, element: <Devices /> },
        { value: "deletions", label: "Deletion Requests", permission: AP.MANAGE_USERS, element: <Deletions /> },
        { value: "archive", label: "Archive", permission: AP.MANAGE_USERS, element: <Archive /> },
        { value: "squads", label: "Squads", permission: AP.MANAGE_USERS, element: <Squads /> },
      ]}
    />
  );
}
